import {
  Grid,
  Dialog,
  Button,
  DialogContent,
  DialogTitle,
  Divider,
} from '@mui/material'
import CurrencyField from '../../../components/CurrencyField/CurrencyField'
import { useState } from 'react'
import { metodoPrograma } from '../../../components/api'

const ModalConfirmaPagamento = ({ data, close }) => {
  const [vlPago, setVlPago] = useState(0.0)

  const handleFalse = () => {
    close(false)
  }

  const confirmaPagamento = async () => {
    const values = {
      idPagamento: data.idPagamento,
      vlPago,
    }
    const res = await metodoPrograma('confirmaPagamento', values)
    if (res.status) handleFalse()
  }

  return (
    <Dialog maxWidth="lg" open={true} onClose={handleFalse}>
      <DialogTitle divider>
        Confirmação de Pagamento - {data?.dsVendedor}
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <CurrencyField
              fullWidth
              value={data.totalComissao}
              variant="outlined"
              margin="dense"
              label="Total a Receber pelas Comissões"
              disabled
              size="small"
            />
          </Grid>
          <Grid item xs={12}>
            <CurrencyField
              fullWidth
              value={vlPago}
              variant="outlined"
              margin="dense"
              label="Total a Pagar"
              size="small"
              onChange={(v) => {
                setVlPago(v)
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Button fullWidth variant="contained" onClick={confirmaPagamento}>
              confirmar pagamento da comissão
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default ModalConfirmaPagamento
